import { Component, input, output } from '@angular/core';
import { SHARED_MENU_IMPORTS } from '@shared/modules/shared-menu-module';
import { NavigationMenuItem } from '../nav-menu-item.model';
@Component({
  selector: 'nav-menu-items',
  imports: [SHARED_MENU_IMPORTS],
  templateUrl: './nav-menu-items.html',
  styles: ``,
})
export class NavMenuItems {
  readonly items = input.required<NavigationMenuItem[]>();
  readonly navigate = output<string>();
}
